// Widget Scripts
import mainSlider from './js/widgets/mainSlider.js';
import tier2CardWidget from './js/widgets/tier2CardWidget.js';
import tier3Events from './js/widgets/tier3Events.js';
import hotbuttons from './js/widgets/hotbuttons.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import tier6cards from './js/widgets/tier6CardWidget.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (globalThis.location.pathname === '/') {
  $(document).ready(function () {
    mainSlider();
    tier2CardWidget();
    tier3Events();
    hotbuttons();
    seoWidget();
    tier6cards();
  });

  $(globalThis).load(function () {
    videoWidget();
  });
}

$(document).ready(function () {
  // Initialize Custom Theme Scripts
});
